import { DefaultService } from '@/services/DefaultService';

export default class SugestaoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    updateSituacao(sugestao) {
        return this._http
            .post(`${this._env}/agro/sugestao/updatesituacao`, sugestao, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw err;
                }
            );
    }

    findAll(column, order, page, limit, situacao, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${this._env}/agro/sugestao.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error('Problems while jobs are loading');
                }
            );
    }

    findAllOrigens() {
        return this._http
            .get(`${this._env}/agro/segestao/origens.json`, this._headers)
            .then((res) => res.body, this.handleError);
    }

    filtroColaboradores() {
        return this._http.get(`${this._env}/agro/sugestao/colaboradores.json`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.verifyError(err);
                throw err;
            }
        );
    }
    findListAssociated(query, limit = 100) {
        return this._http
            .get(
                `${this._env}/promotor/list/associated.json?param=${query}&limit=${limit}`,
                this._headers
            )
            .then((res) => res.body, this.handleError);
    }

    findAllCombo(...params) {
        return this._http
            .get(encodeURI(`${this._env}/agro/sugestao/{id}.json?param=${params}`), this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error('Problems while jobs are loading');
                }
            );
    }

    find(id) {
        return this._http.get(`${this._env}/agro/sugestao/${id}.json`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.verifyError(err);
                throw new Error('Problems while jobs are loading');
            }
        );
    }

    save(form) {
        return this._http.post(`${this._env}/agro/sugestao`, form, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.verifyError(err);
                throw err;
            }
        );
    }
}
